<template>
  <div>
    <v-progress-linear
      :active="isLoading"
      :indeterminate="isLoading"
      absolute
      top
      color="#743063"
    ></v-progress-linear>
    <br />
    <div v-if="unpaidInstallments && unpaidInstallments.length > 0">
   <h3 class="ma-2">الأقساط المستحقة</h3>
    <div >
      <v-card class="ma-2" max-width="400">
        <v-card-text>
          <v-list-item
            v-for="installment in unpaidInstallments"
            :key="installment.id"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="installment.subscriptionName.arabic"
              ></v-list-item-title>

              <v-list-item-subtitle>
                تاريخ الاستحقاق: {{ toDateString(installment.installmentDate) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                >قيمة القسط: {{ installment.amount }} KD</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-list-item-action>
              <v-checkbox
                v-if="isPreparingForPayment"
                v-model="unpaidInstallmentIds[installment.id]"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
          <v-divider inset></v-divider>
          <div class="my-1" v-if="isPreparingForPayment">
            <p>قم باختيار الأقساط التي تريد دفعها ثم اضغط اتمام الدفع</p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            v-if="isPreparingForPayment == false"
            rounded
            dark
            class="ma-1"
            color="#019891"
            @click="isPreparingForPayment = true"
          >
            دفع الأقساط
          </v-btn>

          <v-btn
            v-if="isPreparingForPayment"
            rounded
            dark
            class="ma-1"
            color="#019891"
            @click="isPreparingForPayment = false"
          >
            إلغاء
          </v-btn>
          <v-btn
            :disabled="subscriptionInstallmentIds.length == 0"
            v-if="isPreparingForPayment"
            :loading="isPaying"
            rounded
            :dark="subscriptionInstallmentIds.length != 0"
            class="ma-1"
            color="#743063"
            @click="completePaymentProcess"
          >
            اتمام الدفع
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    </div>
 
 <div v-if="subscriptions && subscriptions.length > 0">
  <h3 class="ma-2">الاشتراكات</h3>

    <div class="ma-1 pa-2">
      <div class="hidden-sm-and-down">
        <v-card class="d-flex flex-wrap my-1" flat max-width="1650">
          <v-card class="ma-1" v-for="s in subscriptions" :key="s.id" max-width="400">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ s.name | localized }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="s.status == 'Active'" color="green"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else color="red">mdi-alpha-x-circle-outline</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>الرصيد</v-list-item-title>

              <v-list-item-subtitle> {{ s.balance }} KD </v-list-item-subtitle>
            </v-list-item>
            <v-card-actions class="justify-center">
              <v-btn
                @click="openDetail(s.id)"
                text
                dark
                class="ma-1"
                color="#743063"
              >
                عرض الأقساط
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </div>
      <div class="hidden-md-and-up">
        <div class="d-flex flex-column align-center">
          <v-card class="ma-1" v-for="s in subscriptions" :key="s.id">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ s.name | localized }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon v-if="s.status == 'Active'" color="green"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else color="red">mdi-alpha-x-circle-outline</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >عدد الأقساط المستحقة: {{ s.numberOfUnpaidInstallments }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle
                  >الرصيد: {{ s.balance }} KD
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions class="justify-center">
              <v-btn
                @click="openDetail(s.id)"
                text
                dark
                class="ma-1"
                color="#743063"
              >
                عرض التفاصيل
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
 </div>
  

    <h3 class="ma-2">مشاريع يمكن الاشتراك بها</h3>
    <div class="scrolling-div">
      <div
        v-for="item in subscriptionItems"
        :key="item.id"
        class="scrolling-card"
      >
        <v-card class="ma-1" flat max-width="1650">
          <SmallItemComponent :itemProp="item"></SmallItemComponent>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

import { mapGetters } from "vuex";
import SmallItemComponent from "@/components/SmallItemComponent";

export default {
  name: "MySubscriptions",
  props: {},
  components: { SmallItemComponent },
  //********************** */
  data: () => ({
    isLoading: false,
    isPaying: false,
    isPreparingForPayment: false,
    unpaidInstallmentIds: {},
  }),

  watch: {
    $route: "loadSubscriptions",
  },

  //********************** */
  computed: {
    ...mapGetters("Subscription", {
      subscriptions: "subscriptions",
      unpaidInstallments: "unpaidInstallments",
      externalPaymentUrl: "externalPaymentUrl",
    }),

    ...mapGetters("Catalog", {
      subscriptionItems: "subscriptionItems",
      homePageItems: "homePageItems",
    }),

    subscriptionInstallmentIds: function () {
      let dict = this.unpaidInstallmentIds;
      var filtered = Object.keys(dict).reduce(function (filtered, key) {
        if (dict[key] == true) filtered[key] = dict[key];
        return filtered;
      }, {});

      let ids = Object.keys(filtered);

      return ids;
    },
  },

  //********************** */
  methods: {
    loadSubscriptions: async function () {
      this.isLoading = true;

      await this.$store.dispatch("Subscription/loadCustomerSubscriptions");
      await this.$store.dispatch("Subscription/loadUnpaidInstallments"); 
      this.prepareUnpaidSubscriptions();
      await this.loadItems();
      this.isLoading = false;
    },
    loadItems: async function () {
      await this.$store.dispatch("Catalog/loadSubscriptionItems");
    },
    openDetail: function (id) {
      this.$router.push({ path: `/SubscriptionDetail/${id}` });
    },
    toDateString: function (date) {
      if (date) {
        return formatDate(date);
      }

      return "-";
    },
    prepareUnpaidSubscriptions: function () {
      this.unpaidInstallmentIds = this.unpaidInstallments.reduce(
        (a, x) => ({ ...a, [x.id]: false }),
        {}
      );
    },
    completePaymentProcess: async function () {
      let model = {
        subscriptionInstallmentIds: this.subscriptionInstallmentIds.map(
          function (item) {
            return parseInt(item, 0);
          }
        ),
      };

      this.isPaying = true;
      try {
        await this.$store.dispatch("Subscription/createInvoice", model);
        //this.isPaying = false;
        //console.log(this.externalPaymentUrl);
        window.location = this.externalPaymentUrl.url;
      } catch (error) {
        this.showError = true;
        this.isPaying = false;

        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
    },
  },


  //********************** */
  async created() {
    await this.loadSubscriptions();
  },
  async mounted() {
    
  },
};
</script>


<style scoped>
.custom-card {
  background: rgb(0, 188, 39);
  background: linear-gradient(
    40deg,
    rgba(0, 188, 39, 1) 24%,
    rgba(0, 161, 32, 1) 76%
  );
  max-width: 300px;
}
.custom-pill {
  border-radius: 25px;
  max-width: 280px;
  border: 1px solid #bbbbba;
  font-size: 14px;
}

.scrolling-div {
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
  margin: 0px;
}

.scrolling-card {
  display: inline-block;
  vertical-align: top;
}

.scrolling-div::-webkit-scrollbar {
  display: none;
}
</style>